import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const deleteFleet = (fleetId) => {
  return Helpers.delete(`${Constants.FLEETS_URL}/${fleetId}`, {});
};

export const getFleets = () => {
  return Helpers.get(Constants.FLEETS_URL).then((res) =>
    (res.body || []).sort((a, b) => {
      var nameA = a.Name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.Name.toUpperCase(); // ignore upper and lowercase
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    })
  );
};

export const saveFleet = (fleet) => {
  return Helpers.post(`${Constants.FLEETS_URL}`, {}, fleet);
};

export const updateAllFleets = () => {
  return Helpers.post(`${Constants.FLEETS_URL}/updateAll`);
};

export const updateFleet = (fleetId) => {
  return Helpers.post(`${Constants.FLEETS_URL}/${fleetId}/update`);
};
